import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  link: {
    textDecoration: "none",
    color: theme.palette.links,
    "&:hover, &:active, &:visited": {
      color: theme.palette.links,
      textDecoration: "underline"
    }
  }
}));

const OSSLinkCell = ({ column, row }) => {
  const classes = useStyles();
  const { dataKey } = column;
  const { url, externalLink = false } = row;
  const value = row[dataKey];

  const link = externalLink ? (
    <a
      className={classes.link}
      href={url}
      rel="noreferrer noopener"
      target="_blank"
    >
      {value}
    </a>
  ) : (
    <Link className={classes.link} to={url}>
      {value}
    </Link>
  );
  return link;
};

export { OSSLinkCell };
